import { useContext } from 'react';
import YearContext from 'src/contexts/YearContext';

const useYear = () => useContext(YearContext);

export default useYear;
